export enum SHIPMENT_COLUMN_NAME {
  CLIENT_NAME = "clientName",
  EXTERNAL_ORDER_ID = "externalOrderID",
  EXTERNAL_PARTNER_SHIPMENT_ID = "externalPartnerShipmentId",
  EXTERNAL_PARTNER_REGION = "externalPartnerRegion",
  RECIPIENT_NAME = "recipientName",
  RECIPIENT_COMPANY = "recipientCompany",
  RECIPIENT_PHONE = "recipientPhone",
  RECIPIENT_ADDRESS_TYPE = "recipientAddressType",
  RECIPIENT_ADDRESS_LINE_1 = "recipientAddressLine1",
  RECIPIENT_ADDRESS_LINE_2 = "recipientAddressLine2",
  RECIPIENT_CITY = "recipientCity",
  RECIPIENT_STATE = "recipientState",
  RECIPIENT_ZIP = "recipientZip",
  DELIVERY_INSTRUCTIONS = "deliveryInstructions",
  CREATED_ON = "createdOn",
  CREATED_BY = "createdby",
  UPDATED_ON = "updatedOn",
  UPDATED_BY = "updatedby",
}

export enum SHIPMENT_LABEL_NAME {
  CLIENT_NAME = "Client Name",
  EXTERNAL_ORDER_ID = "External Order ID",
  EXTERNAL_PARTNER_SHIPMENT_ID = "External Partner Shipment Id",
  EXTERNAL_PARTNER_REGION = "External Partner Region",
  RECIPIENT_NAME = "Recipient Name",
  RECIPIENT_COMPANY = "Recipient Company",
  RECIPIENT_PHONE = "Recipient Phone",
  RECIPIENT_ADDRESS_TYPE = "Recipient Address Type",
  RECIPIENT_ADDRESS_LINE_1 = "Recipient AddressLine 1",
  RECIPIENT_ADDRESS_LINE_2 = "Recipient AddressLine 2",
  RECIPIENT_CITY = "Recipient City",
  RECIPIENT_STATE = "Recipient State",
  RECIPIENT_ZIP = "Recipient Zip",
  DELIVERY_INSTRUCTIONS = "Delivery Instructions",
  CREATED_ON = "Created On",
  CREATED_BY = "Created by",
  UPDATED_ON = "Updated On",
  UPDATED_BY = "Updated by",
}

export const SHIPMENT_FILTER_COLUMN_OPTIONS = [
  {
    label: SHIPMENT_LABEL_NAME.CLIENT_NAME,
    value: SHIPMENT_COLUMN_NAME.CLIENT_NAME,
  },
  {
    label: SHIPMENT_LABEL_NAME.EXTERNAL_ORDER_ID,
    value: SHIPMENT_COLUMN_NAME.EXTERNAL_ORDER_ID,
  },
  {
    label: SHIPMENT_LABEL_NAME.EXTERNAL_PARTNER_SHIPMENT_ID,
    value: SHIPMENT_COLUMN_NAME.EXTERNAL_PARTNER_SHIPMENT_ID,
  },
  {
    label: SHIPMENT_LABEL_NAME.EXTERNAL_PARTNER_REGION,
    value: SHIPMENT_COLUMN_NAME.EXTERNAL_PARTNER_REGION,
  },
  {
    label: SHIPMENT_LABEL_NAME.RECIPIENT_NAME,
    value: SHIPMENT_COLUMN_NAME.RECIPIENT_NAME,
  },
  {
    label: SHIPMENT_LABEL_NAME.RECIPIENT_COMPANY,
    value: SHIPMENT_COLUMN_NAME.RECIPIENT_COMPANY,
  },
  {
    label: SHIPMENT_LABEL_NAME.RECIPIENT_PHONE,
    value: SHIPMENT_COLUMN_NAME.RECIPIENT_PHONE,
  },
  {
    label: SHIPMENT_LABEL_NAME.RECIPIENT_ADDRESS_TYPE,
    value: SHIPMENT_COLUMN_NAME.RECIPIENT_ADDRESS_TYPE,
  },
  {
    label: SHIPMENT_LABEL_NAME.RECIPIENT_ADDRESS_LINE_1,
    value: SHIPMENT_COLUMN_NAME.RECIPIENT_ADDRESS_LINE_1,
  },
  {
    label: SHIPMENT_LABEL_NAME.RECIPIENT_ADDRESS_LINE_2,
    value: SHIPMENT_COLUMN_NAME.RECIPIENT_ADDRESS_LINE_2,
  },
  {
    label: SHIPMENT_LABEL_NAME.RECIPIENT_CITY,
    value: SHIPMENT_COLUMN_NAME.RECIPIENT_CITY,
  },
  {
    label: SHIPMENT_LABEL_NAME.RECIPIENT_STATE,
    value: SHIPMENT_COLUMN_NAME.RECIPIENT_STATE,
  },
  {
    label: SHIPMENT_LABEL_NAME.RECIPIENT_ZIP,
    value: SHIPMENT_COLUMN_NAME.RECIPIENT_ZIP,
  },
  {
    label: SHIPMENT_LABEL_NAME.DELIVERY_INSTRUCTIONS,
    value: SHIPMENT_COLUMN_NAME.DELIVERY_INSTRUCTIONS,
  },
  {
    label: SHIPMENT_LABEL_NAME.CREATED_ON,
    value: SHIPMENT_COLUMN_NAME.CREATED_ON,
  },
  {
    label: SHIPMENT_LABEL_NAME.CREATED_BY,
    value: SHIPMENT_COLUMN_NAME.CREATED_BY,
  },
  {
    label: SHIPMENT_LABEL_NAME.UPDATED_ON,
    value: SHIPMENT_COLUMN_NAME.UPDATED_ON,
  },
  {
    label: SHIPMENT_LABEL_NAME.UPDATED_BY,
    value: SHIPMENT_COLUMN_NAME.UPDATED_BY,
  },
];
